import { Component, Input, ViewChild, TemplateRef, forwardRef } from '@angular/core';
import { SubToolbarItem, ToolbarItem, ToolbarItemEvent } from '../../interfaces/tool-bar-item.interface';
import { ToolBarToolComponent } from '@progress/kendo-angular-toolbar';
import { ButtonModule, SplitButtonModule } from '@progress/kendo-angular-buttons';
import { BadgeModule } from '@progress/kendo-angular-indicators';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule } from '@angular/common';

@Component({
    providers: [
        {
            provide: ToolBarToolComponent,
            useExisting: forwardRef(() => CustomToolBarComponent)
        }
    ],
    selector: 'app-custom-tool-bar',
    imports: [SplitButtonModule, BadgeModule, TranslateModule, FontAwesomeModule, CommonModule, ButtonModule],
    templateUrl: './custom-tool-bar.component.html',
    styleUrls: ['./custom-tool-bar.component.css']
})
export class CustomToolBarComponent {

  @ViewChild('toolbarTemplate', { static: true })
  public toolbarTemplate: TemplateRef<unknown>;

  @Input() items: ToolbarItem[];

  constructor()
  {
  }

  trackByToolbarItem(index: number, item: ToolbarItem): string {
    return item.text;
  }

  trackByEvent(index: number, item: ToolbarItemEvent): string {
    return item.title;
  }

  itemSelected(item: ToolbarItem) {
    if (item.action) {
      item.action();
    }
  }

  subItemSelected(item: SubToolbarItem) {
    if (item && item.action) {
      item.action();
    }
  }

}
